import React from 'react'

interface Props {
    message: string
}
class ErrorCover extends React.Component<Props> {
    public static defaultProps = {
        message: 'An internal error occured',
    }

    public render() {
        return (
            <div className="cover cover-error">
                <big className="text-center">
                    <h3>
                        <span className="fa fa-exclamation-circle" /> Sorry, an error occured
                    </h3>
                    <p>{this.props.message}</p>
                </big>
            </div>
        )
    }
}

export default ErrorCover
